export default {
    getModelContratista: (state) => {
        return state.contratista
    },
    getContratistaTpl: (state) => {
        if(state.operacion==="list"){
            return "contratistaList"
        }
    }
}